module.exports = __webpack_public_path__ + "static/img/mb-09.11972a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/mb-09.jpg
// module id = POaV
// module chunks = 1